export const SET_CURRENT_SM = 'SET_CURRENT_SM';
export const UNSET_CURRENT_SM = 'UNSET_CURRENT_SM';

export const SET_SM_POPUP_FEEDBACK_DATA = 'SET_SM_POPUP_FEEDBACK_DATA';
export const RESET_SM_POPUP_FEEDBACK_DATA = 'RESET_SM_POPUP_FEEDBACK_DATA';
